
/* SOW Nutrition 2026 · generated by site-sownutrition/tema/gerar_tema.py */
(function(){
  var loja = document.getElementById('loja');
  if (!loja) return;
  var bm = document.getElementById('b-menu');
  if (bm) bm.addEventListener('click', function(){
    var aberto = loja.classList.toggle('menu-aberto');
    bm.setAttribute('aria-expanded', aberto ? 'true' : 'false');
  });

  // home banners: they rotate; the dots switch them
  var slides = Array.prototype.slice.call(loja.querySelectorAll('.banner .slide')),
      dots = Array.prototype.slice.call(loja.querySelectorAll('.pontos button')), atual = 0, t;
  function mostra(i){
    atual = i;
    slides.forEach(function(s, k){ s.classList.toggle('on', k === i); });
    dots.forEach(function(d, k){ d.classList.toggle('on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  dots.forEach(function(d, k){ d.addEventListener('click', function(){ clearInterval(t); mostra(k); }); });
  if (slides.length > 1 && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    t = setInterval(function(){ mostra((atual + 1) % slides.length); }, 6000);
  }
  // swipe on phones: left/right switches the banner and stops the rotation (user, 2026-10-21); a swipe never opens
  // the banner's link, a tap still does
  var banner = loja.querySelector('.banner');
  if (banner && slides.length > 1) {
    var x0 = null, y0 = 0, arrastou = false;
    banner.addEventListener('touchstart', function(e){ var p = e.touches[0]; x0 = p.clientX; y0 = p.clientY; arrastou = false; }, {passive: true});
    banner.addEventListener('touchend', function(e){
      if (x0 === null) return;
      var p = e.changedTouches[0], dx = p.clientX - x0, dy = p.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        arrastou = true;
        clearInterval(t);
        mostra((atual + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
      }
    }, {passive: true});
    banner.addEventListener('click', function(e){ if (arrastou) { e.preventDefault(); arrastou = false; } }, true);
  }

  // collection sorting: Shopify sorts on the server
  var ord = loja.querySelector('[data-ordenar]');
  if (ord) ord.addEventListener('change', function(){
    var u = new URL(location.href); u.searchParams.set('sort_by', ord.value); u.searchParams.delete('page'); location.href = u.toString();
  });

  // quantity buttons (product page and cart)
  Array.prototype.forEach.call(loja.querySelectorAll('.qtd'), function(q){
    var inp = q.querySelector('[data-qtd-input]'); if (!inp) return;
    var minimo = inp.hasAttribute('data-envia') ? 0 : 1;
    function muda(d){
      inp.value = Math.max(minimo, Math.min(99, (parseInt(inp.value, 10) || minimo) + d));
      if (inp.hasAttribute('data-envia')) { var f = inp.form, b = f && f.querySelector('[name="update"]'); if (b) b.click(); }
    }
    if (inp.hasAttribute('data-envia')) {
      var atualiza = function(){ var b = inp.form && inp.form.querySelector('[name="update"]'); if (b) b.click(); };
      inp.addEventListener('change', atualiza);
      inp.addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); atualiza(); } });
    }
    var menos = q.querySelector('[data-menos]'), mais = q.querySelector('[data-mais]');
    if (menos) menos.addEventListener('click', function(){ muda(-1); });
    if (mais) mais.addEventListener('click', function(){ muda(1); });
  });

  // product gallery
  var g = loja.querySelector('[data-galeria]');
  if (g) {
    var imgs = g.querySelectorAll('.g-img'), bts = g.querySelectorAll('.g-mini button');
    Array.prototype.forEach.call(bts, function(b, i){
      b.addEventListener('click', function(){
        Array.prototype.forEach.call(imgs, function(im, k){ im.classList.toggle('on', k === i); });
        Array.prototype.forEach.call(bts, function(x, k){ x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      });
    });
  }

  // buy bar: appears once the buy button scrolls out of view
  var barra = loja.querySelector('[data-barra]'), alvo = loja.querySelector('.acoes-compra');
  if (barra && alvo && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(es){
      var e = es[0], passou = !e.isIntersecting && e.boundingClientRect.top < 0;
      barra.classList.toggle('visivel', passou);
      barra.setAttribute('aria-hidden', passou ? 'false' : 'true');
      var b = barra.querySelector('button'); if (b) b.tabIndex = passou ? 0 : -1;
    }).observe(alvo);
  }
})();

(function(){
  var caixa = document.querySelector('[data-aval]');
  if (!caixa || !window.fetch || !window.DOMParser) return;
  var mais = document.querySelector('[data-aval-mais]'), pagina = 0, POR = 6;
  var MESES = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  function txt(r, q){ var e = r.querySelector(q); return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function el(tag, cls, t){ var e = document.createElement(tag); if (cls) e.className = cls; if (t) e.textContent = t; return e; }
  function nome(t){ var p = t.split(' ').filter(Boolean); return p.length > 1 ? p[0] + ' ' + p[p.length - 1].charAt(0).toUpperCase() + '.' : (p[0] || 'Cliente'); }
  function carrega(){
    pagina++;
    mais.disabled = true;
    var l = encodeURIComponent(caixa.dataset.loja);
    fetch('https://api.judge.me/reviews/reviews_for_widget?url=' + l + '&shop_domain=' + l + '&platform=shopify&page=' + pagina +
          '&per_page=' + POR + '&product_id=' + encodeURIComponent(caixa.dataset.produto))
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(d){
        var doc = new DOMParser().parseFromString(d.html || '', 'text/html');
        Array.prototype.forEach.call(doc.querySelectorAll('.jdgm-rev'), function(r){
          var corpo = txt(r, '.jdgm-rev__body');
          if (!corpo) return;
          var nota = parseInt((r.querySelector('.jdgm-rev__rating') || {getAttribute: function(){ return '5'; }}).getAttribute('data-score'), 10) || 5;
          var a = el('article', 'aval');
          var est = el('span', 'aval-est', '★★★★★'.slice(0, nota) + '☆☆☆☆☆'.slice(0, 5 - nota));
          est.setAttribute('role', 'img'); est.setAttribute('aria-label', nota + ' de 5 estrelas');
          a.appendChild(est);
          var t = txt(r, '.jdgm-rev__title');
          if (t && corpo.indexOf(t) !== 0) a.appendChild(el('h3', '', t));
          a.appendChild(el('p', '', corpo));
          var info = nome(txt(r, '.jdgm-rev__author'));
          if (r.getAttribute('data-verified-buyer') === 'true') info += ' · Compra verificada';
          var tm = r.querySelector('.jdgm-rev__timestamp'), dt = tm && new Date(tm.getAttribute('datetime'));
          if (dt && !isNaN(dt)) info += ' · ' + MESES[dt.getMonth()] + ' de ' + dt.getFullYear();
          a.appendChild(el('small', '', info));
          caixa.appendChild(a);
        });
        caixa.hidden = !caixa.children.length;
        mais.hidden = pagina * POR >= (d.total_count || 0);
        mais.disabled = false;
      })
      .catch(function(){ mais.hidden = true; });
  }
  mais.addEventListener('click', carrega);
  carrega();
})();

(function(){
  var raiz = document.getElementById('shopify-section-carrinho-lateral');
  if (!raiz || !window.fetch || !window.DOMParser) return;
  var url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var aberta = false, antes = null, ultimo = null;
  function gaveta(){ return raiz.querySelector('[data-gaveta]'); }
  function aplica(){
    var g = gaveta(), f = raiz.querySelector('[data-gaveta-fundo]');
    if (!g) return;
    g.classList.toggle('aberta', aberta);
    g.setAttribute('aria-hidden', aberta ? 'false' : 'true');
    if (f) f.hidden = !aberta;
    document.documentElement.classList.toggle('gaveta-aberta', aberta);
    Array.prototype.forEach.call(document.querySelectorAll('.sacola'), function(s){
      var i = s.querySelector('i'), t = s.querySelector('.total');
      if (i) i.textContent = g.getAttribute('data-gv-itens');
      if (t) t.textContent = g.getAttribute('data-gv-total');
    });
  }
  function abre(){
    if (!aberta) antes = document.activeElement;
    aberta = true; aplica();
    var g = gaveta(); if (g) g.focus();
  }
  function fecha(){
    aberta = false; aplica();
    if (antes && antes.focus) antes.focus();
  }
  function renderiza(){
    return fetch(url + '?sections=carrinho-lateral', {credentials: 'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(d){
        var doc = new DOMParser().parseFromString(d['carrinho-lateral'] || '', 'text/html');
        var novo = doc.getElementById('shopify-section-carrinho-lateral');
        if (novo) raiz.innerHTML = novo.innerHTML;
        aplica();
      });
  }
  function erro(msg){
    var e = raiz.querySelector('[data-gv-erro]');
    if (e) { e.textContent = msg || ''; e.hidden = !msg; }
  }
  function ocupado(b, sim){
    if (!b) return;
    if (sim) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    if ('disabled' in b && b.tagName === 'BUTTON') b.disabled = sim;
  }
  function adiciona(corpo, botao, reserva){
    ocupado(botao, true);
    var form = corpo instanceof FormData;
    fetch(url + 'cart/add.js', {method: 'POST', credentials: 'same-origin',
      headers: form ? {'Accept': 'application/json'} : {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: form ? corpo : JSON.stringify(corpo)})
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){ return renderiza().then(function(){ erro(''); abre(); }); },
            function(j){ return renderiza().then(function(){ erro((j && j.description) || 'Não foi possível adicionar agora. Tente de novo.'); abre(); }); })
      .catch(function(){ if (reserva) reserva(); })
      .then(function(){ ocupado(botao, false); });
  }

  // the last submit button clicked (Safari before 15.4 has no event.submitter)
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('button[type="submit"]');
    if (b) ultimo = b;
  }, true);

  document.addEventListener('click', function(e){
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var t = e.target.closest ? e.target : e.target.parentElement;
    var a = t.closest('a.comprar[href*="/cart/add"]');
    if (a) {
      var u = new URL(a.href, location.href), id = parseInt(u.searchParams.get('id'), 10);
      if (id) {
        e.preventDefault();
        adiciona({items: [{id: id, quantity: parseInt(u.searchParams.get('quantity'), 10) || 1}]}, a, function(){ location.href = a.href; });
      }
      return;
    }
    if (t.closest('.sacola') && !document.body.classList.contains('modelo-cart')) {
      e.preventDefault(); abre(); renderiza(); return;
    }
    if (t.closest('[data-gaveta-fechar]') || t.matches('[data-gaveta-fundo]')) { fecha(); return; }
    var b = t.closest('[data-gv-linha]');
    if (b) {
      b.disabled = true;
      fetch(url + 'cart/change.js', {method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({line: parseInt(b.getAttribute('data-gv-linha'), 10), quantity: parseInt(b.getAttribute('data-gv-qtd'), 10)})})
        .then(renderiza)
        .then(function(){ var g = gaveta(); if (g) g.focus(); })
        .catch(function(){ location.href = url + 'cart'; });
    }
  });

  document.addEventListener('submit', function(e){
    var f = e.target;
    if (e.defaultPrevented || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var sub = e.submitter || ultimo;
    if (sub && sub.name === 'return_to') return;              // "Comprar agora": straight to checkout
    e.preventDefault();
    var fd = new FormData(f);
    adiciona(fd, sub || f.querySelector('[type="submit"]'), function(){ f.submit(); });
  });

  document.addEventListener('keydown', function(e){
    if (!aberta) return;
    if (e.key === 'Escape') { fecha(); return; }
    if (e.key !== 'Tab') return;
    var g = gaveta(), focos = g ? g.querySelectorAll('a[href],button:not([disabled])') : [];
    if (!focos.length) return;
    var p = focos[0], u = focos[focos.length - 1];
    if (e.shiftKey && (document.activeElement === p || document.activeElement === g)) { e.preventDefault(); u.focus(); }
    else if (!e.shiftKey && document.activeElement === u) { e.preventDefault(); p.focus(); }
  });
})();

// "Atendimento" button: opens and closes the help panel (Esc, a click outside or the × close it)
(function(){
  var raiz = document.querySelector('[data-atd]');
  if (!raiz) return;
  var botao = raiz.querySelector('[data-atd-botao]'), painel = raiz.querySelector('#atd-painel');
  function abre(sim){
    painel.hidden = !sim;
    botao.setAttribute('aria-expanded', sim ? 'true' : 'false');
    if (sim) { var a = painel.querySelector('a'); if (a) a.focus(); }
  }
  botao.addEventListener('click', function(){ abre(painel.hidden); });
  raiz.querySelector('[data-atd-fechar]').addEventListener('click', function(){ abre(false); botao.focus(); });
  // the balloon "Precisa de ajuda para comprar?": shown once per visit, 6 s after the page opens, hidden after 20 s;
  // never on top of the open panel, the cart drawer or the first-order popup
  var balao = raiz.querySelector('[data-atd-balao]');
  if (balao) {
    var CHAVE = 'sow-balao-vendas', visto = false;
    try { visto = sessionStorage.getItem(CHAVE) === '1'; } catch (e) {}
    var esconde = function(){ balao.hidden = true; try { sessionStorage.setItem(CHAVE, '1'); } catch (e) {} };
    if (!visto) setTimeout(function(){
      var h = document.documentElement.classList;
      if (!painel.hidden || h.contains('pp-aberto') || h.contains('gaveta-aberta')) return;
      balao.hidden = false;
      try { sessionStorage.setItem(CHAVE, '1'); } catch (e) {}
      setTimeout(function(){ balao.hidden = true; }, 20000);
    }, 6000);
    balao.querySelector('[data-atd-balao-fechar]').addEventListener('click', esconde);
    balao.querySelector('a').addEventListener('click', function(){ setTimeout(esconde, 0); });
    botao.addEventListener('click', esconde);
  }
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !painel.hidden) { abre(false); botao.focus(); } });
  document.addEventListener('click', function(e){ if (!painel.hidden && !raiz.contains(e.target)) abre(false); });
})();

// first-order popup: opens from the header pill and the footer box; sends the lead to the leads service (Data Crazy),
// then shows the coupon
(function(){
  var pp = document.querySelector('[data-pp]');
  if (!pp) return;
  var fundo = document.querySelector('[data-pp-fundo]'), form = pp.querySelector('[data-pp-form]'), erro = pp.querySelector('[data-pp-erro]');
  var antes = null;
  function abre(email){
    antes = document.activeElement;
    pp.hidden = false; fundo.hidden = false;
    document.documentElement.classList.add('pp-aberto');
    if (email) form.email.value = email;
    (form.nome.value ? form.email : form.nome).focus();
  }
  function fecha(){
    pp.hidden = true; fundo.hidden = true;
    document.documentElement.classList.remove('pp-aberto');
    if (antes && antes.focus) antes.focus();
  }
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a.primeiro-pedido,[data-abre-pp]');
    if (a) { e.preventDefault(); abre(); }
  });
  var news = document.getElementById('newsletter');
  if (news) news.addEventListener('submit', function(e){
    e.preventDefault();
    var c = news.querySelector('[type=email]');
    abre(c ? c.value.trim() : '');
  });
  pp.querySelector('[data-pp-fechar]').addEventListener('click', fecha);
  fundo.addEventListener('click', fecha);
  document.addEventListener('keydown', function(e){
    if (pp.hidden) return;
    if (e.key === 'Escape') { fecha(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(pp.querySelectorAll('a[href],button,input,[tabindex="-1"][data-pp-ok-tit]'), function(x){ return x.offsetParent !== null && x.name !== 'empresa'; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  // WhatsApp: (00) 00000-0000 while typing
  var fone = form.whatsapp;
  fone.addEventListener('input', function(){
    var d = fone.value.replace(/\D/g, '').replace(/^55(?=\d{10,11}$)/, '').slice(0, 11);
    fone.value = d.length > 6 ? '(' + d.slice(0, 2) + ') ' + d.slice(2, d.length - 4) + '-' + d.slice(-4) : d.length > 2 ? '(' + d.slice(0, 2) + ') ' + d.slice(2) : d;
  });
  function mostra(msg, campo){
    erro.textContent = msg; erro.hidden = !msg;
    Array.prototype.forEach.call(form.querySelectorAll('input'), function(i){ i.removeAttribute('aria-invalid'); });
    if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
  }
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var nome = form.nome.value.trim(), email = form.email.value.trim(), digitos = fone.value.replace(/\D/g, '');
    if (nome.length < 2) return mostra('Escreva o seu nome.', form.nome);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return mostra('Confira o seu e-mail.', form.email);
    if (digitos.length < 10 || digitos.length > 11) return mostra('Confira o seu WhatsApp, com o DDD.', fone);
    if (!form.consentimento.checked) return mostra('Para continuar, marque que você concorda com a Política de privacidade.', form.consentimento);
    mostra('');
    var botao = form.querySelector('[type=submit]');
    botao.disabled = true; botao.setAttribute('aria-busy', 'true');
    var dados = {nome: nome, email: email, whatsapp: digitos, consentimento: true, empresa: form.empresa.value, origem: location.pathname};
    // the lead goes only to the leads service (Data Crazy): Shopify's customer form refuses posts from scripts (400)
    var envios = [];
    var ponto = pp.getAttribute('data-endpoint');
    // the CRM never stands between the customer and the coupon: if the leads service fails, she still gets it
    if (ponto) envios.unshift(fetch(ponto, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(dados)})
      .then(function(r){ if (!r.ok) console.warn('leads: ' + r.status); }, function(){ console.warn('leads: sem resposta'); }));
    Promise.all(envios).then(function(){
      pp.querySelector('[data-pp-etapa=form]').hidden = true;
      var ok = pp.querySelector('[data-pp-etapa=ok]'); ok.hidden = false;
      pp.querySelector('[data-pp-nome]').textContent = nome.split(' ')[0] + '!';
      var cupom = pp.getAttribute('data-cupom');
      pp.querySelector('[data-pp-com-cupom]').hidden = !cupom;
      pp.querySelector('[data-pp-sem-cupom]').hidden = !!cupom;
      if (cupom) pp.querySelector('[data-pp-codigo]').textContent = cupom;
      pp.querySelector('[data-pp-ok-tit]').focus();
    }, function(){
      mostra('Não conseguimos enviar agora. Tente de novo em instantes ou fale com a gente pelo WhatsApp.');
    }).then(function(){ botao.disabled = false; botao.removeAttribute('aria-busy'); });
  });
  var copiar = pp.querySelector('[data-pp-copiar]');
  copiar.addEventListener('click', function(){
    var c = pp.getAttribute('data-cupom');
    if (navigator.clipboard) navigator.clipboard.writeText(c).then(function(){ copiar.textContent = 'Copiado'; });
  });
})();

// a link to a question (#onde-comprar, from the product page) opens it
(function(){
  function abre(rolar){
    var d = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (d && d.tagName === 'DETAILS') { d.open = true; if (rolar) d.scrollIntoView({block: 'center'}); }
  }
  abre(false);
  // centre it after the page settles: the browser's own jump to the anchor comes after the fonts load
  window.addEventListener('load', function(){ setTimeout(function(){ abre(true); }, 60); });
  window.addEventListener('hashchange', function(){ abre(true); });
})();

// "Rastreie seu pedido" (templates/page.rastreio.liquid): e-mail + CPF -> her purchases (store, Hotmart, Assiny) -> one purchase's
// tracking, from the tracking service (rastreio-worker); all on the store, so Shopify shows no "leave" warning
(function(){
  var raiz = document.querySelector('[data-rastreio]');
  if (!raiz) return;
  var servico = (raiz.getAttribute('data-servico') || '').replace(/\/+$/, '');
  var externo = raiz.getAttribute('data-externo') || '';
  var form = raiz.querySelector('[data-rastreio-form]'), botao = raiz.querySelector('[data-rastreio-botao]');
  var erro = raiz.querySelector('[data-rastreio-erro]'), res = raiz.querySelector('[data-rastreio-res]');
  var dados = null, lista = [];
  var NOMES = {preparando: 'Em preparação', enviado: 'Enviado', 'a-caminho': 'A caminho', entregue: 'Entregue', cancelado: 'Cancelado'};
  var ETAPAS = ['Pedido confirmado', 'Enviado', 'A caminho', 'Entregue'];
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); }
  // dates as "14 de out. de 2026" (and the time for events); a plain date is the local day, not UTC midnight
  function data(s, hora){
    if (!s) return '';
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s), d = m ? new Date(+m[1], m[2] - 1, +m[3]) : new Date(/^\d{4}-\d{2}-\d{2} \d/.test(s) ? s.replace(' ', 'T') : s);
    if (isNaN(d)) return s;
    var o = {day: 'numeric', month: 'short', year: 'numeric'};
    if (hora && !m && /\d{2}:\d{2}/.test(s)) { o.hour = '2-digit'; o.minute = '2-digit'; }
    return d.toLocaleString('pt-BR', o);
  }
  function mostraErro(html){ erro.innerHTML = html || ''; erro.hidden = !html; }
  function falha(j){
    if (j.erro === 'nao-encontrado') return 'Não encontramos compras com esse e-mail e esse CPF. Confira os dados: use o e-mail e o CPF informados na compra.';
    if (j.erro === 'limite') return 'Muitas tentativas seguidas. Espere um minuto e tente de novo.';
    if (j.erro === 'dados') return 'Confira o e-mail e o CPF (11 números).';
    return 'O rastreio está fora do ar agora. Tente de novo em alguns minutos' + (externo ? ' ou veja no <a href="' + esc(externo) + '">site de rastreio</a>' : '') + '.';
  }
  function pede(rota, corpo){
    return fetch(servico + rota, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(corpo)})
      .then(function(r){ return r.json().catch(function(){ return {}; }); });
  }
  function pilula(s){ return '<span class="rastreio-pilula ' + esc(s) + '">' + esc(NOMES[s] || s) + '</span>'; }
  function itens(p){ return esc((p.itens || []).join(', ')); }
  function mostraLista(){
    res.innerHTML = '<p class="rastreio-k">' + (lista.length > 1 ? 'Suas compras' : 'Sua compra') + '</p><ul class="rastreio-lista">' +
      lista.map(function(p, i){
        return '<li><button type="button" class="rastreio-item" data-i="' + i + '"><b>' + esc(data(p.comprado_em)) + pilula(p.situacao) +
          '</b><span>' + itens(p) + ' · pedido ' + esc(p.pedido) + (p.canal ? ' · ' + esc(p.canal) : '') + '</span><i aria-hidden="true">→</i></button></li>';
      }).join('') + '</ul>';
  }
  function mostraPedido(p){
    var etapas = p.situacao === 'cancelado' ? '' : '<ol class="rastreio-etapas">' + ETAPAS.map(function(e, k){
      var n = k + 1;
      return '<li class="' + (n <= p.etapa ? 'feita' : '') + (n === p.etapa ? ' atual' : '') + '"' + (n === p.etapa ? ' aria-current="step"' : '') + '>' + e + '</li>';
    }).join('') + '</ol>';
    // carrier, code and forecast come from Estoca once the carrier collects the order; before that, say what is coming
    // instead of leaving them out (user, 2026-10-21). Third item: true for a placeholder (shown in a softer colour)
    var fatos = [], pendente = p.situacao === 'preparando' || p.situacao === 'enviado' || p.situacao === 'a-caminho';
    if (p.transportadora || pendente) fatos.push(['Transportadora', p.transportadora || 'A definir', !p.transportadora]);
    if (p.codigo || pendente) fatos.push(['Código de rastreio', p.codigo || (p.situacao === 'preparando' ? 'Aguardando envio' : 'Aguardando coleta'), !p.codigo]);
    if (p.entregue_em) fatos.push(['Entregue em', data(p.entregue_em)]);
    else if (p.previsao || pendente) fatos.push(['Previsão de entrega', p.previsao ? data(p.previsao) : 'A definir', !p.previsao]);
    if (p.enviado_em && !p.entregue_em) fatos.push(['Enviado em', data(p.enviado_em)]);
    var eventos = p.eventos || [], nota = '';
    if (p.situacao === 'preparando') nota = 'Seu pedido está sendo separado. Assim que a transportadora coletar, o rastreio aparece aqui.';
    else if (p.situacao === 'enviado' && !eventos.length) nota = 'Seu pedido foi enviado. Os movimentos da transportadora aparecem aqui assim que ela registrar a coleta.';
    else if (p.situacao === 'cancelado') nota = 'Este pedido foi cancelado.';
    res.innerHTML = (lista.length > 1 ? '<button type="button" class="rastreio-voltar" data-voltar>← Ver todas as compras</button>' : '') +
      '<div class="rastreio-card"><h2>Pedido ' + esc(p.pedido) + pilula(p.situacao) + '</h2>' +
      '<div class="rastreio-compra"><div><b>Produtos:</b> ' + itens(p) + '</div><div><b>Data:</b> ' + esc(data(p.comprado_em)) + '</div>' +
      (p.canal ? '<div><b>Loja:</b> ' + esc(p.canal) + '</div>' : '') + '</div>' + etapas +
      (fatos.length ? '<dl class="rastreio-fatos">' + fatos.map(function(f){ return '<div><dt>' + f[0] + '</dt><dd' + (f[2] ? ' class="a-definir"' : '') + '>' + esc(f[1]) + '</dd></div>'; }).join('') + '</dl>' : '') +
      (nota ? '<p class="rastreio-nota">' + nota + '</p>' : '') +
      (eventos.length ? '<div class="rastreio-hist"><p class="rastreio-k">Histórico da entrega</p><ol class="rastreio-eventos">' + eventos.map(function(e){
        return '<li><b>' + esc(e.titulo) + '</b><span>' + esc(data(e.data, true)) + (e.local ? ' · ' + esc(e.local) : '') + '</span></li>';
      }).join('') + '</ol></div>' : '') + '</div>';
    res.scrollIntoView({behavior: 'smooth', block: 'start'});
  }
  function abre(i){
    var p = lista[i];
    mostraErro('');
    res.setAttribute('aria-busy', 'true');
    pede('/rastreio/pedido', {email: dados.email, doc: dados.doc, pedido: p.id}).then(function(j){
      res.removeAttribute('aria-busy');
      if (!j.ok) { mostraErro(falha(j)); return; }
      mostraPedido(j);
    }).catch(function(){ res.removeAttribute('aria-busy'); mostraErro(falha({})); });
  }
  res.addEventListener('click', function(e){
    var b = e.target.closest('[data-i]');
    if (b) { abre(+b.getAttribute('data-i')); return; }
    if (e.target.closest('[data-voltar]')) { mostraLista(); res.scrollIntoView({behavior: 'smooth', block: 'start'}); }
  });
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var email = form.elements.email.value.trim(), doc = form.elements.doc.value.replace(/\D/g, '');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) || [11, 14].indexOf(doc.length) < 0) { mostraErro(falha({erro: 'dados'})); return; }
    if (!servico) { mostraErro(falha({})); return; }
    mostraErro(''); res.innerHTML = '';
    var txt = botao.textContent;
    botao.disabled = true; botao.textContent = 'Procurando…';
    dados = {email: email, doc: doc};
    pede('/rastreio', dados).then(function(j){
      botao.disabled = false; botao.textContent = txt;
      if (!j.ok) { mostraErro(falha(j)); return; }
      lista = j.pedidos || [];
      if (lista.length === 1) abre(0); else mostraLista();
    }).catch(function(){ botao.disabled = false; botao.textContent = txt; mostraErro(falha({})); });
  });
})();
